import FileModel from './globals/FileModel';

export default class DemandPdfModel extends FileModel {
  static get path() {
    return '/backend/demands/{id}/pdf/{locale}';
  }
}
